import { SmileOutlined, UserOutlined } from '@ant-design/icons';
import { notification, Result, Steps } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useHistory, useLocation } from 'react-router-dom';
import { SignupOtpInitiateRequest } from '../../../../Models/Request/Authentication/Signup';
import { UserLoginSuccessResponse } from '../../../../Models/Response/Authentication/Otp';
import {
  signupOtp,
  signupRedirectionOtpInit,
  signupRedirectionOtpVerify,
  signupVerification,
} from '../../../../Services/AuthenticationServices/AuthenticationServices';
import { setCredentialsLocalStorage } from '../../../../Services/LocalStorageServices';
import { QueryParams, Routes } from '../../../../Utils/Constants/routes';
import { vuaIdSuffix } from '../../../../Utils/Constants/vuaIdSuffix';
import getIsRedirection from '../../../../Utils/redirectionUtility';
import OTPInputComponent from '../../../Common/Components/OTPModal';
import LoginSignupForm from '../Form';
import LoginSignupSidePanel from '../Greetings';
import './index.css';

const SignupComponent: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState('');
  const [signUpDTO, setSignUpDTO] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    pin: '',
    vuaId: '' + vuaIdSuffix.value,
    isTermsAndConditionAgreed: true,
  });
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const redirect: any = location.state;

  const signupWithPhonenumber = (values: any) => {
    signupRedirectionOtpInit(values)
      .then((res: any) => res.data)
      .then((res) => {
        setIsOTPModalVisible(true);

        setOTPUniqueId(res);
      });
  };

  const signup = (values: SignupOtpInitiateRequest) => {
    if (values.vuaId.indexOf(vuaIdSuffix.value) === -1) {
      values = { ...values, vuaId: values.vuaId + vuaIdSuffix.value };
    }
    setSignUpDTO(values);
    signupOtp(values)
      .then((res) => res.data)
      .then((res) => {
        setIsOTPModalVisible(true);
        setOTPUniqueId(res.otpUniqueID);
      });
  };
  const verify = (values: any) => {
    if (getIsRedirection()) {
      signupWithPhonenumber(values);
    } else {
      signup(values);
    }
  };

  const closeModal = () => {
    setIsOTPModalVisible(false);
  };

  const signUpRedirect = () => {
    setTimeout(() => {
      history.push(Routes.linkAccounts);
    }, 3000);
  };

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  const onSignupVerificationOtpRedirection = (values: any) => {
    signupRedirectionOtpVerify({
      phoneNumber: redirect.phoneNumber,
      code: values.otp,
      otpUniqueID,
      isTermsAndConditionAgreed: true,
      isFromRedirection: true,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        notification.success({
          message: t('Signup Success'),
        });
        setCurrent(current + 1);
        setCredentialsLocalStorage(res);
        setIsOTPModalVisible(false);
        history.push(query.get(QueryParams.redirect));
      });
  };

  const onSignupVerificationOtp = (otp: string) => {
    signupVerification({
      otp,
      vuaId: signUpDTO.vuaId,
      pin: signUpDTO.pin,
      isTermsAndConditionAgreed: true,
      otpUniqueID,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        notification.success({
          message: t('Signup Success'),
        });
        setCurrent(current + 1);
        setCredentialsLocalStorage(res);
        setIsOTPModalVisible(false);
        signUpRedirect();
      });
  };

  const logIn = () => {
    history.push(Routes.login);
  };

  return (
    <>
      {!getIsRedirection() && (
        <OTPInputComponent
          onCancel={closeModal}
          isOpen={isOTPModalVisible}
          onOtpSubmit={onSignupVerificationOtp}
          okText={t('CONFIRM')}
          title={t('Signup')}
          // tslint:disable-next-line: jsx-no-lambda
          onResend={() => verify(signUpDTO)}
          mobileNumber={signUpDTO.phoneNumber}
        />
      )}
      <div className='signupRoot'>
        {current !== 1 && <LoginSignupSidePanel className='customClass' />}
        <div className='signForm flexCustomCss'>
          <Steps className='steps' current={current}>
            <Steps.Step title={t('Create Account')} icon={<UserOutlined />} />
            <Steps.Step title={t('Done')} icon={<SmileOutlined />} />
          </Steps>
          {current === 0 && (
            <>
              <LoginSignupForm
                className={'signFormTitle'}
                formType={t('Create Account')}
                buttonSubSectionText={t('Already have an account?')}
                buttonSubSectionButton={t('Login')}
                formSubmit={
                  isOTPModalVisible
                    ? onSignupVerificationOtpRedirection
                    : verify
                }
                subButtonClick={logIn}
                buttonText={!!redirect ? t('Sign Up') : t('Send OTP')}
                phoneNumber={!!redirect && redirect.phoneNumber}
                isOtpInputVisible={isOTPModalVisible}
                onResendOtp={verify}
              />
            </>
          )}
          {current === 1 && (
            <Result
              status='success'
              title={`${t('Welcome')} ${signUpDTO.firstName}`}
              subTitle={t('Successfully created an account')}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SignupComponent;
